import type { EditorialWriteStatus } from "../types";

export const STATUS_CHANGE_MESSAGES: Record<EditorialWriteStatus, string> = {
  pending: "Returned to pending",
  ready_for_editing: "Marked ready for editing",
  ready_for_translation: "Marked ready for translation",
  ready_for_release: "Marked ready for release",
};
